import './Popup.scss';
import { bool2str, forAll } from '@bopf/util';

class HeaderPopup {
    constructor(element) {
        this._element = element;
        this._toggle = document.querySelector(`[aria-controls="${this._element.id}"]`);
        this._previouslyFocusedElement = null;
        this._onCloseClick = this._onCloseClick.bind(this);
        this._onOpenClick = this._onOpenClick.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._addEventListeners();
    }

    get open() {
        return this._element.getAttribute('aria-expanded') === 'true';
    }

    get focusables() {
        return Array.from(this._element.querySelectorAll('a[href], button, input'))
            .filter(e => e.offsetParent !== null);
    }

    set open(value) {
        if (value === this.open) {
            return;
        }
        this._element.setAttribute('aria-expanded', bool2str(value));
        this._toggle.setAttribute('aria-expanded', bool2str(value));
        const x = document.body.scrollLeft + document.documentElement.scrollLeft;
        const y = document.body.scrollTop + document.documentElement.scrollTop;
        let event;
        if (value) {
            document.body.style.overflow = 'hidden';
            document.body.scrollLeft = x;
            document.body.scrollTop = y;
            this._previouslyFocusedElement = document.activeElement;
            if (!this._element.contains(document.activeElement)) {
                this.focusables[0].focus();
            }
            event = new CustomEvent('open');
        } else {
            document.body.style.overflow = '';
            window.scrollTo(x, y);
            event = new CustomEvent('close');
            if (this._previouslyFocusedElement) {
                this._previouslyFocusedElement.focus();
            }
        }
        this._element.dispatchEvent(event);
    }

    /**
     * @param {PointerEvent} e
     * @private
     */
    _onCloseClick(e) {
        this.open = false;
        e.preventDefault();
    }

    /**
     * @param {PointerEvent} e
     * @private
     */
    _onOpenClick(e) {
        this.open = true;
        e.preventDefault();
    }

    /**
     * @param {KeyboardEvent} e
     * @private
     */
    _onKeyDown(e) {
        if (this.open) {
            if (e.key === 'Escape') {
                this.open = false;
            }
            if (e.key === 'Tab' && !e.ctrlKey) {
                const focusable = this.focusables;
                if (!this._element.contains(document.activeElement)) {
                    focusable[0].focus();
                } else {
                    let current = null;
                    for (let i = 0; i < focusable.length; i++) {
                        if (focusable[i] === document.activeElement) {
                            current = i;
                            break;
                        }
                    }
                    if (current !== null) {
                        const i = (current + (e.shiftKey ? -1 : 1) + focusable.length) % focusable.length;
                        focusable[i].focus();
                    }
                }
                e.preventDefault();
            }

        }
    }

    _addEventListeners() {
        this._element.querySelector('button').addEventListener('click', this._onCloseClick);
        this._toggle.addEventListener('click', this._onOpenClick);
        window.addEventListener('keydown', this._onKeyDown);
    }

    static init() {
        forAll('.js-header__popup', e => new HeaderPopup(e));
    }
}

export {
    HeaderPopup,
};
